// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--123-green:#00a385;--123-light-grey:#efefef;--map-height:480px;--webkit-box-shadow-bottom:0 5px 6px -6px rgba(0,0,0,0.6);--moz-box-shadow-bottom:0 5px 6px -6px rgba(0,0,0,0.6);--box-shadow-bottom:0 5px 6px -6px rgba(0,0,0,0.6)}.p-autocomplete-input{max-width:100%}.mapboxgl-control-container{display:none}", ""]);
// Exports
module.exports = exports;
